import $ from 'jquery';

const expand = {
  init: (elementHtmlTag) => {
    /*
    * Init
    * */
    $(elementHtmlTag).find('button.expand--button').each((index, buttonHtmlTag) => {
      _expandPrivate.open($(buttonHtmlTag), $(elementHtmlTag));
    });

    /*
    * Add event
    * */
    $(elementHtmlTag).find('button.expand--button').on('click', (e) => {
      _expandPrivate.open($(e.currentTarget), $(elementHtmlTag));
    });
  },
};

const _expandPrivate = {
  isExists: (htmlElement) => {
    return htmlElement
      && htmlElement.length > 0
      && typeof htmlElement != 'undefined';
  },
  open: (expandButtonElement, parent) => {
    /*
    * Check if valid variable
    * */
    if (!_expandPrivate.isExists(expandButtonElement)) {
      return;
    }

    /*
    * Get area to expand
    * */
    let expandAreaId = expandButtonElement.attr('aria-controls');
    let expandAreaElement = parent.find('#' + expandAreaId);

    /*
    * Expand or not
    * */
    let hadClassOpen = !parent.hasClass('expand--close');

    parent
      .removeClass(!hadClassOpen ? 'expand--close' : 'expand--open')
      .addClass(hadClassOpen ? 'expand--close' : 'expand--open');
    expandAreaElement.attr('aria-expanded', !hadClassOpen);
  },
};

export default expand;
